<template>
  <div v-if="accommodation !== null">

    <p v-if="chatRoom === null">
      {{ $t('loading') }}...
    </p>
    <div class="room" v-else-if="chatRoom !== false">
      <LazySocketIoChat :room="chatRoom" :client="client"/>
    </div>

    <div class="alert alert-danger mt-4" v-if="tyrionResponseStatus && tyrionResponseStatus.status === 'error'">
      {{ tyrionResponseStatus.msg }}
    </div>
  </div>
</template>
<script setup lang="ts">
import LazySocketIoChat from "~/components/admin/chat/messenger/small_chat";
import {onMounted, PropType, ref} from "vue";
import Accommodation from "~/lib/models/Accommodation";
import Client from "~/lib/models/Client";
import {tyrionResponse} from "~/composables/tyrionResponse";
import {useNuxtApp} from "#app";

const props = defineProps({
  accommodation: Object as PropType<Accommodation>,
  client: Object as PropType<Client>
})

const {$i18n, $socketApi} = useNuxtApp();
const {setTyrionResponseStatus, tyrionResponseStatus} = tyrionResponse();

onMounted(() => {
  if (props.accommodation && props.client.id != props.accommodation.owner.id) {
    initAccommodationChat();
  }
})

const chatRoom = ref(null);

const initAccommodationChat = () => {
  $socketApi.postSocketUrl("/api/chat/rooms", {
    body: {
      code: 'owner-contact-' + props.client.id + '-' + props.accommodation.id,
      recipients: [props.accommodation.owner.id],
      subject: $i18n.t('contact-owner')
    }
  }).then((res) => {
    if (res.status === 'success') {
      chatRoom.value = res.data;
    } else {
      chatRoom.value = false;
      setTyrionResponseStatus('error', res.message);
    }
  }).catch((e) => {
    chatRoom.value = false;
    setTyrionResponseStatus('error', (e.response && e.response.data && e.response.data.message) ? e.response.data.message : `Chat error: ${e.message}`);
  })
};

</script>
